import { Button, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Profile } from '@par/shared/types/player';
import { EditProfileModal } from '../../modals/EditProfileModal';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';

type PropTypes = {
  onUpdateProfile: (updatedUsername?: string) => void;
  profile: Profile;
  viewProfile: Profile;
};
export const ProfileInfoStack = ({
  onUpdateProfile,
  profile,
  viewProfile,
}: PropTypes) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <div>
      <EditProfileModal
        onUpdateProfile={onUpdateProfile}
        openModal={openModal}
        profile={profile}
        setOpenModal={setOpenModal}
      ></EditProfileModal>
      <Stack spacing={1}>
        {profile.id === viewProfile.id ? (
          <Button variant="outlined" onClick={() => setOpenModal(true)}>
            <BadgeOutlinedIcon sx={{ mr: 1 }} />
            Edit Profile
          </Button>
        ) : null}
      </Stack>
    </div>
  );
};
